import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var SemanticFooter = function SemanticFooter(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(SemanticFooter.displayName);
  return /*#__PURE__*/React.createElement("footer", {
    className: getClassName()
  }, children);
};

SemanticFooter.displayName = "SemanticFooter";
export default SemanticFooter;